import i18next from 'i18next';
import React, { useState } from 'react';

import { ToggleSwitch } from '@commons/utils/styledLibraryComponents';
import Text from '@commons/Text';

import { Container, Description, ToggleRow } from './styledComponents';

const PennylaneGenerateModal = ({ storeCount, orderCount, onGroupByStoreChange }) => {
  const [groupByStore, setGroupByStore] = useState(false);

  const handleToggle = () => {
    const newValue = !groupByStore;

    setGroupByStore(newValue);
    onGroupByStoreChange(newValue);
  };

  return (
    <Container>
      <Description>
        {`${i18next.t('ORDERS.ORDERS.PENNYLANE_GENERATE_MODAL_STORE_PART', {
          count: storeCount,
        })} ${i18next.t('ORDERS.ORDERS.PENNYLANE_GENERATE_MODAL_ORDER_PART', {
          count: orderCount,
        })}. ${i18next.t('ORDERS.ORDERS.PENNYLANE_GENERATE_MODAL_DESCRIPTION_SUFFIX')}`}
      </Description>
      <ToggleRow>
        <ToggleSwitch
          checked={groupByStore}
          handleClick={handleToggle}
          id="pennylane-group-by-store"
        />
        <Text>{i18next.t('ORDERS.ORDERS.PENNYLANE_GENERATE_MODAL_TOGGLE_LABEL')}</Text>
      </ToggleRow>
    </Container>
  );
};

export default PennylaneGenerateModal;
